module.exports = __webpack_public_path__ + "static/img/zhiguisai.0bc33bf6.png";